import React, { useEffect, useState } from "react";
import { useLocation, useNavigate } from "react-router-dom";
import { useDispatch, useSelector } from "react-redux";
import { RootState } from "../../../redux/store";
import { clearTraditionalQuoteData } from "../../../redux/reducer/locationSlice/locationSlice";
import CustomerOrder from ".";
import TraditionalOrder from "./TraditionalOrder";

const TradNonTrad: React.FC = () => {
  const [quoteType, setQuoteType] =
    useState<"traditional" | "nonTraditional">("nonTraditional");
  const [savedQuoteData, setSavedQuoteData] = useState<any>(null);
  const navigate = useNavigate();
  const location = useLocation();
  const dispatch = useDispatch();

  // Get Traditional Quote data from Redux if available, otherwise fall back to location state
  const { traditionalQuoteData } = useSelector((state: RootState) => state.locationState);
  const { state: locationState } = location;
  const state = traditionalQuoteData || locationState;

  useEffect(() => {
    if (state?.page === "Save Quotation") {
      if (savedQuoteData?.service?.name === "LTL" || state?.orderType === "LTL") {
        setQuoteType("traditional");
      } else {
        setQuoteType("nonTraditional");

      }
    }
  }, [])

  useEffect(() => {
    if (
      state?.quoteType === "traditional" &&
      state?.selectedData?.orderTypeName !== "LTL + Final Mile"
    ) {
      setQuoteType(state?.quoteType);
    }
  }, [state]);

  // Switching the order type by hand starts a fresh order. Selecting a quote parks
  // it either in Redux (`traditionalQuoteData`, the LTL path) or in the route state,
  // and the form that mounts next seeds itself from whichever is set, so both have
  // to be dropped here or the previous flow's data carries over.
  const handleRadioChange = (type: "traditional" | "nonTraditional") => {
    if (type === quoteType) return;
    setQuoteType(type);
    dispatch(clearTraditionalQuoteData());
    if (location.state) {
      navigate(location.pathname, { replace: true, state: {} }); // Clear location state
    }
  };


  return (
    <div className="details" id="top">
      <div className="form single-form">
        <section className="form__section">
          <h1 className="form__section__title form__section__title--flex">
            New Order
            <div className="btn__group">
              <button
                className="btn btn__primary"
                onClick={() => navigate("/saved-quotes")}
              >
                View Saved Quotes
              </button>
            </div>
          </h1>

          <div className="formRow">
            <div className="formCol">
              <div className="form__Field">
                <div className="form__radio form__radio--gray">
                  <div className="form__radio__option">
                    <input
                      type="radio"
                      id="traditionalOrder"
                      name="orderType"
                      value="traditional"
                      className="form__radio__input"
                      checked={quoteType === "traditional"}
                      onChange={() => handleRadioChange("traditional")}
                    />
                    <label
                      htmlFor="traditionalOrder"
                      className="form__radio__label"
                    >
                      LTL Order
                    </label>
                  </div>
                  <div className="form__radio__option">
                    <input
                      type="radio"
                      name="orderType"
                      id="nonTraditional"
                      value="nonTraditional"
                      className="form__radio__input"
                      checked={quoteType === "nonTraditional"}
                      onChange={() => handleRadioChange("nonTraditional")}
                    />
                    <label
                      htmlFor="nonTraditional"
                      className="form__radio__label"
                    >
                      Final Mile, LTL + Final Mile, Expedited Order
                    </label>
                  </div>
                </div>
              </div>
            </div>
          </div>

          <div className="child-form align-with-header">
            {quoteType === "nonTraditional" ? (
              <CustomerOrder quoteTypeRadio={quoteType} setQuoteType={setQuoteType} />
            ) : (
              <TraditionalOrder quoteTypeRadio={quoteType} setQuoteType={setQuoteType} />
            )}
          </div>
        </section>
      </div>
    </div>
  );
};

export default TradNonTrad;
